module.exports = __webpack_public_path__ + "media/images/flags/gb-eng-1fa89df2764a3f107c345ec3d56886e8.svg";